export const copilotEndpoints = {
  copilot: '/ai/copilot',
} as const;
